import { render, staticRenderFns } from "./ProfileHeaderInfo.vue?vue&type=template&id=0c873c82&scoped=true&"
import script from "./ProfileHeaderInfo.vue?vue&type=script&lang=ts&"
export * from "./ProfileHeaderInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileHeaderInfo.vue?vue&type=style&index=0&id=0c873c82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c873c82",
  null
  
)

export default component.exports